var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('localization',{attrs:{"language":_vm.language}},[_c('intl',{attrs:{"locale":"hu"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }